export const ApiCacheTags = {
    cashflow: {
        dashboard: 'CashflowDashboard',
    },
    invoice: {
        list: 'Invoices',
        item: 'InvoiceItem',
        pdf: 'InvoicePDF',
        numbers: 'InvoiceNumbers',
        invoicingStatusCounts: 'InvoicingStatusCounts',
        invoicingStatuses: 'InvoicingStatuses',
        commissionsForInvoicing: 'CommissionsForInvoicing',
        customerSelfInvoicePaymentsStatus: 'CustomerSelfInvoicePaymentsStatus',
    },
    attachment: {
        list: 'Attachments',
        item: 'Attachment',
        file: 'AttachmentFile',
        uploadLink: 'AttachmentUploadLink',
    },
    country: {
        list: 'Countries',
    },
    user: {
        item: 'UserItem',
        profilePicture: 'UserProfilePicture',
        list: 'Users',
    },
    metrics: {
        get: 'Metrics',
    },
    ares: {
        companies: 'AresCompanies',
    },
    commission: {
        list: 'Commissions',
        item: 'CommissionItem',
        pdf: 'CommissionPDF',
        email: 'CommissionEmail',
        summary: 'CommissionSummary',
        numbers: 'CommissionNumbers',
        metricsStates: 'CommissionMetricsStates',
    },
    customer: {
        list: 'Customers',
        item: 'CustomerItem',
        profilePicture: 'CustomerProfilePicture',
        registration: 'CustomerRegistration',
    },
    carrier: {
        list: 'Carriers',
        item: 'CarrierItem',
    },
    customerUser: {
        list: 'CustomerUsers',
        item: 'CustomerUserItem',
        invitation: 'CustomerUserInvitation',
    },
    customerContact: {
        list: 'CustomerContacts',
        item: 'CustomerContactItem',
    },
    location: {
        list: 'CustomerLocations',
        item: 'CustomerLocationItem',
    },
    geocoding: {
        address: 'GeocodedAddress',
        reverseAddress: 'ReverseGeocodedAddress',
    },
    expense: {
        list: 'Expenses',
        item: 'ExpenseItem',
    },
    earlyPay: {
        settings: 'EarlyPaySettings',
        overview: 'EarlyPayOverview',
        dashboard: 'EarlyPayDashboard',
    },
} as const;

export const ApiCacheTagsArray = Object.values(ApiCacheTags).flatMap((tag) =>
    typeof tag === 'object' ? Object.values(tag) : tag,
);
